/*
 * © Copyright 2015
 * Landcare Research
 *
 * Dual License with
 *
 * GPL v3 - See http://www.gnu.org/licenses/gpl-3.0.txt
 *
 * Any derivative work needs to be contributed back to this project
 * unless otherwise agreed with Landcare Research, New Zealand.
 */
/*
import "core-js/stable";
import "regenerator-runtime/runtime";
*/

// Import angularjs - defines the global angular
import 'angular/angular.min';
import 'angular-ui-bootstrap';
import 'angular-sanitize/angular-sanitize.min';
import 'angular-resource/angular-resource.min';
import 'angular-animate/angular-animate.min';

// Third party angular modules:
import './allmighty-autocomplete/script/autocomplete';
import 'angular-tree-control';
import 'ng-password-strength';

import './utility/qs';
import './ol/register-proj';

import {appPage} from './modules/app-page-smap';
import {LTServices} from './lt-ng/lt-services';
import {LTMap} from './lt-ng/lt-directives';

import {OEMapControlService} from "./lt-ng/map-controls/oe-map-control-service";
import {TransparentPaneCoordinateAdjustmentService} from "./services/oe/transparent_pane_coordinate_adjustment";
import {StubReportService} from "./services/features-api/stub_report_service";

LTServices.init('smap_v2', OEMapControlService, TransparentPaneCoordinateAdjustmentService);
LTMap.init();
appPage.init(StubReportService);

